import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { ConfigService, MaintenanceStatus } from '../services/config.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

/**
 * MaintenanceGuard - Prüft Maintenance-Status und IsTestUser
 * 
 * Logik:
 * - MaintenanceActive = FALSE → Alle Seiten erlaubt
 * - MaintenanceActive = TRUE + User = null → /maintenance
 * - MaintenanceActive = TRUE + IsTestUser = false → Auto-Logout + /maintenance
 * - MaintenanceActive = TRUE + IsTestUser = true → Zugriff OK
 */
export const maintenanceGuard: CanActivateFn = () => {
  const config = inject(ConfigService);
  const auth = inject(AuthService);
  const router = inject(Router);

  return config.getMaintenanceStatusFresh().pipe(
    take(1),
    map(status => {
      // ✅ Maintenance NICHT aktiv → alle Seiten erlaubt
      if (!status.isActive) {
        if (!environment.production) {
          console.log('[MAINTENANCE_GUARD] ✅ Maintenance OFF - Allow access');
        }
        return true;
      }

      // ❌ Maintenance AKTIV - Prüfe User
      const user = auth.user();

      // ⏳ CRITICAL FIX: Wenn isAuthenticated aber user null → /me lädt noch!
      // Gib true zurück, nicht redirect! /me wird bald fertig sein.
      if (auth.isAuthenticated() && !user) {
        if (!environment.production) {
          console.log('[MAINTENANCE_GUARD] ⏳ isAuthenticated=true aber user=null → /me lädt noch - Allow access');
        }
        return true; // ← Erlauben! Guard wird neu evaluiert wenn user Signal sich ändert
      }

      // Nur redirect wenn NICHT authenticated UND kein user
      if (!user) {
        if (!environment.production) {
          console.log('[MAINTENANCE_GUARD] ❌ Maintenance ON - No user AND NOT authenticated - Redirect to /maintenance');
        }
        router.navigate(['/maintenance']);
        return false;
      }

      // 🔴 User existiert aber IsTestUser = false → Auto-Logout!
      if (!user.isTestUser) {
        if (!environment.production) {
          console.log('[MAINTENANCE_GUARD] ❌ Maintenance ON - User is NOT TestUser - Auto-Logout + Redirect');
        }
        auth.logout();
        router.navigate(['/maintenance']);
        return false;
      }

      // ✅ TestUser darf rein
      if (!environment.production) {
        console.log('[MAINTENANCE_GUARD] ✅ Maintenance ON - User IS TestUser - Allow access');
      }
      return true;
    })
  );
};
